<template>
  <div v-if="recyclable.active" class="mb-1 recyclable-consent">
    <div class="form-check">
      <input id="recyclable" type="checkbox" class="form-check-input" :checked="recyclable.checked" @change="update">
      <label class="form-check-label" for="recyclable">
        {{ recyclable.text }}
      </label>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      recyclable: state => state.recyclable,
    }),
  },
  methods: {
    update (e) {
      this.$store.commit('recyclable/SET', e.target.checked);
    },
  },
};
</script>
